import { KeyPlan } from '../../types';
import api from '../../utils/api';
import { omit } from 'lodash/fp';

export const updateKeyPlan = (variables: KeyPlan) =>
  api.put({
    url: `/property/keyplan/${variables.id}`,
    variables: omit(['id'], variables),
  });
